import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import SearchBar from "../../../components/common/board/SearchFilterBar";
import BoardToolbar from "../../../components/common/board/BoardToolbar";
import BoardTable from "../../../components/common/board/BoardTable";
import BoardPagination from "../../../components/common/board/BoardPagination";

import { getPhotoBoardList } from "../../../api/const";

export default function PhotoBoardSelect({ isOpen, onClose, onSelect }) {
  const { id: projectId } = useParams();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 검색 값들 (PhotoBoard와 동일한 구조)
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("title");
  const [dateFilter, setDateFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const columns = [
    {
      key: "title",
      header: "제목",
      headerAlign: "center",
      align: "center",
      render: (row) => <div className="truncate max-w-[250px]">{row.title}</div>,
    },
    {
      key: "created_by",
      header: "작성자",
      width: 120,
      align: "center",
    },
    {
      key: "date",
      header: "작성일",
      width: 150,
      align: "center",
      render: (row) =>
        row.date ? new Date(row.date).toLocaleDateString("ko-KR") : "-",
    },
  ];

  const fetchData = async () => {
    if (!isOpen || !projectId) return;

    setLoading(true);
    setError("");

    try {
      const res = await getPhotoBoardList(projectId, {
        [searchField]: q,
        start_date: startDate,
        end_date: endDate,
        page,
        page_size: pageSize,
      });

      setRows(res.results ?? res);
      setTotal(res.count ?? res.total ?? res.length);
    } catch (err) {
      console.error(err);
      setError("사진대지 목록을 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [isOpen, page, pageSize]);

  const handleSearch = () => {
    setPage(1);
    fetchData();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[200] flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-xl w-[1100px] max-h-[90vh] overflow-hidden flex flex-col">

        {/* 상단 Toolbar */}
        <div className="p-4 border-b bg-gray-50">
          <BoardToolbar
            right={
              <>
                <SearchBar
                  q={q}
                  onChangeQ={setQ}
                  searchField={searchField}
                  onChangeSearchField={setSearchField}
                  dateFilter={dateFilter}
                  onChangeDateFilter={setDateFilter}
                  startDate={startDate}
                  endDate={endDate}
                  onDateChange={({ start, end }) => {
                    setStartDate(start);
                    setEndDate(end);
                  }}
                  onSearch={handleSearch}
                  pageSize={pageSize}
                  onChangePageSize={setPageSize}
                  searchFieldOptions={[
                    { value: "title", label: "제목" },
                    { value: "author", label: "작성자" },
                  ]}
                />

                <button className="btn-basic ml-4" onClick={onClose}>
                  닫기
                </button>
              </>
            }
          />
        </div>

        {/* 리스트 테이블 */}
        <div className="flex-1 overflow-auto page-box">
          <BoardTable
            columns={columns}
            rows={rows}
            loading={loading}
            error={error}
            emptyText="사진대지가 없습니다."
            onRowClick={(row) => {
              onSelect(row);
              onClose();
            }}
          />
        </div>

        {/* 페이지네이션 */}
        <div className="border-t p-3">
          <BoardPagination
            page={page}
            pageSize={pageSize}
            total={total}
            onPageChange={setPage}
          />
        </div>
      </div>
    </div>
  );
}
